import apiClient from './api';
import { Theme } from 'types';

export interface ThemeCreateRequest {
  name: string;
}

export interface ThemeUpdateRequest {
  name: string;
}

export const adminThemeService = {
  /** 테마 목록 조회 */
  getThemes: async (universityId: number): Promise<Theme[]> => {
    const response = await apiClient.get<Theme[]>(
      `/universities/${universityId}/themes`
    );
    return response.data;
  },

  /** 테마 시설 추가 */
  addFacility: async (themeId: number, facilityId: number): Promise<void> => {
    await apiClient.post(`/admin/themes/${themeId}/facilities`, { facilityId }, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    });
  },

  /** 테마 시설 삭제 */
  removeFacility: async (themeId: number, facilityId: number): Promise<void> => {
    await apiClient.delete(`/admin/themes/${themeId}/facilities/${facilityId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    });
  },

  /** 테마 삭제 */
  deleteTheme: async (themeId: number): Promise<void> => {
    await apiClient.delete(`/admin/themes/${themeId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    });
  },

  /** 테마 수정 */
  updateTheme: async (themeId: number, data: ThemeUpdateRequest): Promise<void> => {
    await apiClient.patch(`/admin/themes/${themeId}`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    });
  },

  /** 테마 생성 */
  create: async (universityId: number, data: ThemeCreateRequest): Promise<void> => {
    await apiClient.post(`/admin/universities/${universityId}/themes`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    });
  },
};
